/**
 =========================================================
 * Material Kit 2 React - v2.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-kit-react
 * Copyright 2021 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// react-router components

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Kit 2 React components
import Grid2 from "@mui/material/Unstable_Grid2";
import MuiLink from "@mui/material/Link";
import { useNavigate } from "react-router-dom";
import MKBox from "../../../../components/MKBox";
import MKButton from "../../../../components/MKButton";

function DefaultFlagCard({ image, title }) {
  const navigate = useNavigate();

  return (
    <MKBox sx={{ mb: 1, width: 1 }}>
      <Grid2 container>
        <Grid2 xs={12} sx={{ display: "flex", justifyContent: "center" }}>
          <MKButton
            color="primary"
            onClick={() => navigate(`/assessment/${title}`)}
            variant="text"
            size="large"
            disableRipple
            sx={{ textTransform: "none", padding: 0 }}
          >
            {title}
          </MKButton>
        </Grid2>
        <Grid2 xs={12}>
          <MKBox display="flex" justifyContent="center">
            <MuiLink component="button" onClick={() => navigate(`/assessment/${title}`)}>
              <MKBox component="img" src={image} sx={{ height: 1 }} />
            </MuiLink>
          </MKBox>
        </Grid2>
      </Grid2>
    </MKBox>
  );
}

DefaultFlagCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
export default DefaultFlagCard;
